import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { mapActions, mapGetters } from 'vuex';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    contentLoaderMixin,
  ],
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      items: [],
      swiperOptions: {
        loop: false,
        autoplay: 5000,
        direction: 'horizontal',
        pagination: '.hero-unit-slider__pagination',
        paginationClickable: true,
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isShutdownModeOn']),
    classModifiers() {
      return {
        'hero-unit-slider': true,
        'hero-unit-slider--shutdown': this.isShutdownModeOn,
      };
    },
  },
  methods: {
    ...mapActions('browse', ['getCarousel']),
    getBannerUrl(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        return banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        return { name: 'market-details', params: { marketId: banner.carouselData.marketId } };
      }
      return {};
    },
    isUrlExternal(banner) {
      const url = banner.carouselData.carouselItemButton.url || '';
      return url.startsWith('http');
    },
    bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': `url('${url}')`,
      };
    },
    buttonStyleModifiers(button) {
      const styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    },
  },
  created() {
    this.getCarousel()
      .then((data) => {
        this.items = data;
        this.isComponentReady = this.items.length > 0;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/hero-unit-slider/hero-unit-slider.js